import { Map } from "immutable";
import * as React from "react";
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget, AsyncState } from "widgets-for-react";
import { CMSState, ImageSize, Link } from "../../../../cms/blocks/types.gen";
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod";
import { getClassName, link } from "../../../../cms/blocks/utils.gen";
import { ImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen";
import { ExtraImages } from "../../../utils/extra_images.mod";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { PublicSiteState } from "../../../../../public_site.main.mod";

export type quoteBlockProps = {
  blockIndex: number
  quote: string
  person: string
  function: string
  background: "grey" | "white" | "orange"
  primaryButton?: Link
  secondaryButton?: Link
}

export type QuoteBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function quoteBlock<customBlockData>(
  props: quoteBlockProps,
  options?: { style: QuoteBlockStyle; key?: string }
): (s:CMSState<customBlockData, ExtraImages, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData,ExtraImages, PublicSite_CustomPageData>>> {
    return (s: CMSState<customBlockData,ExtraImages, PublicSite_CustomPageData>) => (public_state:PublicSiteState) =>
    mk_widget({
      run: _ => {
        return (
          // <div className={`block block--quote${props.background == 'grey' ? " block--color" : props.background == 'orange' ? " block--orange" : ""}`}>
          <div className={`block block--quote`}>
            <div className="block__inner container container--s grid--block">
              <div className='block__content'>
                <blockquote className='block__quote title--m'>
                  <p>{props.quote}</p>
                </blockquote>

                {props.person && <figcaption className='block__author text--s'>— {props.person}, {props.function}</figcaption>}
                
                {props.primaryButton && <footer className='block__footer'>
                  <div className={"block__clickable"}> 
                    {link(props.primaryButton, {classname: "button button--primary"}, props.primaryButton.title,
                      () => {
                        window.dataLayer.push({
                          event: 'event.refresco',
                          category: 'QuoteBlock',
                          action: props.primaryButton.title,
                          label: window.location.pathname,
                        })
                      })}
                  </div>
                  {props.secondaryButton && 
                    <div className={"block__clickable"}> 
                      {link(props.secondaryButton, {classname: "link link--primary"}, props.secondaryButton.title,
                        () => {
                          window.dataLayer.push({
                            event: 'event.refresco',
                            category: 'QuoteBlock',
                            action: props.primaryButton.title,
                            label: window.location.pathname,
                          })
                        })}
                    </div>
                  }
                </footer>}
              </div>
            </div>
          </div>
        )
      },
    })
}
